var exports = {
  "v": "dialogBody__vdDyFw",
};

module.exports = exports;
